import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import { ref } from 'vue';
import IrrigationService from '@/Services/IrrigationService';
import { formatISODate } from '@/Services/Utils';
import { useMitt } from '@/Plugins/mitt';
import { FormPanel } from '@/@types/Enums';
import { useSpinner } from '@/Plugins/spinner';
import Menu from 'primevue/menu';
import ConfirmationService from '@/Services/ConfirmationService';
import { useToastService } from '@/Plugins/toast-service';
export default /*#__PURE__*/ _defineComponent({
    __name: 'List',
    props: {
        orchard_id: {
            type: Number,
            required: true,
        },
        plot_id: Number,
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const irrigationService = new IrrigationService();
        const emitter = useMitt();
        const spinner = useSpinner();
        const confirmationService = new ConfirmationService();
        const toast = useToastService();
        const items = ref([]);
        const selectedItems = ref([]);
        const bulkActionsMenu = ref();
        const bulkActions = ref([
            {
                label: 'Elimina Selezionati',
                icon: 'pi pi-fw pi-trash',
                command: () => deleteSelected(),
                disabled: () => selectedItems.value.length === 0,
            },
        ]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code'];
        const editItem = (data) => emitter.emit('open-irrigation-form', data);
        const loadItems = () => {
            spinner.show();
            irrigationService
                .getAll(props.orchard_id, props.plot_id)
                .then((irrigations) => {
                items.value = irrigations;
            })
                .finally(() => spinner.hide());
        };
        const deleteSelected = () => {
            const ids = selectedItems.value.map((i) => i.id);
            confirmationService.confirmDeleteMultiple(selectedItems.value.length, () => {
                spinner.show();
                irrigationService
                    .destroy(ids)
                    .then(() => {
                    emitter.emit('irrigation-saved');
                    toast.deleteSuccess();
                })
                    .finally(() => spinner.hide());
            }, () => { });
        };
        loadItems();
        emitter.on('irrigation-saved', () => loadItems());
        const __returned__ = { props, irrigationService, emitter, spinner, confirmationService, toast, items, selectedItems, bulkActionsMenu, bulkActions, filters, globalFilterFields, editItem, loadItems, deleteSelected, get InputText() { return InputText; }, get Button() { return Button; }, DataTable, get Column() { return Column; }, get formatISODate() { return formatISODate; }, get Menu() { return Menu; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
